import React, { useEffect } from 'react';
import { ReactQueryDevtools } from 'react-query/devtools';
import { OktonApplication } from '@okton/platform-ui/application';
import type { OktonQueryBoundaryProps } from '@okton/platform-ui/application';
import { createOktonAxiosAdapter } from '@okton/platform-ui/adapters/axios';
import { createOktonReactQueryBoundary } from '@okton/platform-ui/adapters/react-query';
import oktonBankApi from '../services/oktonBankApi';
import { platformBaseUrl, platformSystemId } from '../services/platform';
import { criaQueryClient } from '../services/queryClient';

const transport = createOktonAxiosAdapter(oktonBankApi);
const Queries = createOktonReactQueryBoundary(criaQueryClient);
const BankQueries: React.FC<OktonQueryBoundaryProps> = ({
  scope,
  children,
}) => (
  <Queries scope={scope}>
    {children}
    {process.env.NODE_ENV === 'development' && <ReactQueryDevtools />}
  </Queries>
);

const PlatformAuthProvider: React.FC = ({ children }) => {
  useEffect(() => {
    // Limpeza transitória das chaves do Bancário anterior, não da sessão central.
    ['access_token', 'refresh_token', 'expires_in', 'user'].forEach(key => {
      localStorage.removeItem(`@okton:${key}`);
    });
    sessionStorage.removeItem('@iflex:token');
  }, []);

  return (
    <OktonApplication
      systemId={platformSystemId}
      platformBaseUrl={platformBaseUrl}
      transport={transport}
      QueryBoundary={BankQueries}
    >
      {children}
    </OktonApplication>
  );
};

export default PlatformAuthProvider;
